import React, {Component} from 'react'
import {connect} from 'react-redux';
import {Form, Input, InputNumber, message, Modal, DatePicker, Checkbox, Button, Select} from 'antd';
import PropTypes from "prop-types";
import moment from 'moment';
import * as APP_CONFIG from "../constants/config";
import FileUpload from "./FileUpload";
import { addAction, updateAction, addFoto, deleteFoto, malfunctionsFetchList } from '../actions/malfunctions';
const FormItem = Form.Item;
const { TextArea } = Input;
const {DateTimeFormat, DateFormat, MySQLDateTimeFormat} = APP_CONFIG;
const storingtypen = APP_CONFIG.defaults.storingtypen;

class ActionEditForm extends Component {

    static propTypes = {
        form: PropTypes.shape({
            validateFieldsAndScroll: PropTypes.func,
            getFieldDecorator: PropTypes.func,
        }),
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string.isRequired,
                actionid: PropTypes.string.isRequired
            })
        }),
        malfunctions: PropTypes.array.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            malfunction: this.getMalfunction(props),
            action: this.getAction(props),
            malfunctionid: props.match.params.id,
            filePath: `https://fileserver.wijzijnopgewekt.nl/app/file?path=`,
            uploadPath: `proptest/malfunctions/${props.match.params.id}/actions/${props.match.params.actionid}`,
            modalIsVisible: false,
            modalImage: '',
        };
    }

    getMalfunction = ({malfunctions, match}) => {
        let thisMalfunction = null;
        // zoek de malfunction op
        malfunctions.forEach((element) => {
            if(element.id === parseInt(match.params.id,10))
                thisMalfunction = element;
        });
        return thisMalfunction;
    }

     getAction = ({malfunctions, match}) => {
         let thisMalfunction = null;
         let thisAction = {...APP_CONFIG.defaults.action};
         thisAction.datum_gepland = moment().format(MySQLDateTimeFormat);

         // zoek de malfunction op
         malfunctions.forEach((element) => {
             if(element.id === parseInt(match.params.id,10))
                 thisMalfunction = element;
         });

         // zoek de action op id
         if(thisMalfunction && thisMalfunction.actions.length){
             thisMalfunction.actions.forEach((element) => {
                 if(element.id === parseInt(match.params.actionid,10)){
                     thisAction = {...element};
                 }
             });
         }
         thisAction.malfunctionId = match.params.id;
         thisAction.crtFotos = [...thisAction.fotos];
         return thisAction;
     }

    onChange = (e) => {
        const key = e.target.id;
        const val = e.target.value;
        this.updateAction(key, val);
    };

    onChangeOplossingType = (value) => {
        this.updateAction('oplossingtype', value);
    };

    // bug: er is geen id op InputNumber + val ipv event wordt gegeven in onchange
    onChangeUrenBesteedOnChange = (val) => {
        this.updateAction('uren_besteed', val);
    }

    onChangeCheckbox = (e) => {
        const key = e.target.id;
        const val = e.target.checked;
        e.target.value = val; // validator kijkt naar val die on is als checked
        this.updateAction(key, val);
    };

    onChangeDatepicker = (moment, key) => {
        //console.log(`key ${key}`);
        const val = moment ? moment.format(MySQLDateTimeFormat) : '';
        this.updateAction(key, val);
    };

    isUnique = (_file) => {
        let unique = true;
        const { action } = this.state;

        action.fotos.forEach(foto => {
            if(foto.bestand === _file)
                unique = false;
        });
        return unique;
    }

    updateAction = (key, val) => {
        const { action } = this.state;
        if(key === 'fotos') {
            console.log(`voeg foto toe: ${val}`);
            if(this.isUnique(val))
                action.fotos.push({id: 0, bestand: val}); // nieuwe fotos met id 0
        }
        else {
            action[key] = val;
        }
        this.setState({action : {...action}});
    };

    removeFoto = () => {

        const { modalImage } = this.state;
        const { action } = this.state;
        //console.log(`verwijderen foto ${modalImage} ...`);
        let i = action.fotos.length;
        let startLen = i;
        while (i--) {
            //console.log(`action.fotos[i].bestand:${action.fotos[i].bestand}`);
            //console.log(`modalimge: ${modalImage}`);
            if (action.fotos[i].bestand === modalImage) {
                action.fotos.splice(i,1);
            }
        }
        if(startLen > action.fotos.length){
            //console.log(`verwijderd: ${modalImage}`);
            this.setState({action : {...action}});
            this.setState({modalImage : ''});
        }

        this.handleCancel(null);
    }

    addAction = async () => {
        const { action, malfunctionid } = this.state;

        try{
            if(action.id === 0){
                //console.log(`todo addaction`);
                let addedAction = await this.props.dispatch(addAction(action));

                let newActionId = addedAction.result.newlyInsertedId;

                //console.log(`addedAction id: ${newActionId}`);

                for (let foto of action.fotos) {
                    if(foto.id === 0){
                        //console.log(`ae form nieuwe action add foto: ${foto.bestand}`);

                        foto.actie_id = newActionId;
                        await this.props.dispatch(addFoto(foto));
                    }
                }
            }
            else{
                // vergelijk bestaande fotos met te posten fotos
                // verwijderen:
                let crtFotos = new Set([...action.crtFotos]);
                let updatedFotos = new Set([...action.fotos]);

                let delFotos = new Set([...crtFotos].filter(x => !updatedFotos.has(x)));

                //console.log(`updateaction, #fotos verwijderen: ${delFotos.length}`);

                for (let foto of delFotos) {
                    //console.log(`delfoto..:${foto.bestand}`);
                    await this.props.dispatch(deleteFoto(foto));
                }

                // toevoegen: aan action de id's 0 van updatedFotos
                for (let foto of action.fotos) {
                    if(foto.id === 0){
                        //console.log(`ae update action add foto: ${foto.bestand}`);

                        foto.actie_id = action.id;
                        await this.props.dispatch(addFoto(foto));
                    }
                }
                await this.props.dispatch(updateAction(action));
            }
            await this.props.dispatch(malfunctionsFetchList());

            this.props.history.push(`/storingen/${malfunctionid}/`);
        }
        catch(err){
            console.error(`error bij add/ update: ${err}`);
        }
    };

    addDocument = (_file) => {

        this.updateAction('fotos', encodeURI(_file));
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                try {
                    this.addAction();
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    }

    toOverview = (id) => {
        this.props.history.push(`/storingen/${id}/`);
    };

    showModal = (_file) => {
        this.setState({
            modalIsVisible: true,
            modalImage: _file,
        });
    }

    handleCancel = (e) => {
        console.log(e);
        this.setState({
            modalIsVisible: false,
        });
    }

    render() {
        const { action, malfunctionid, filePath, modalImage, modalIsVisible, uploadPath } = this.state;
        const { getFieldDecorator } = this.props.form;
        console.log(`uploadpad: ${uploadPath}`);
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },

            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },

        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 0,
                },
            },
        };

        const datum_geplandConfig = {
            rules: [{ type: 'object', required: true, message: 'Datum gepland ook doen!' }],
            //initialValue: (action.datum_gepland&&action.datum_gepland.length)?(moment(action.datum_gepland).format(DateTimeFormat)):(null),
            //defaultValue: moment(action.datum_gepland, MySQLDateTimeFormat).format(DateTimeFormat)
            initialValue: moment(action.datum_gepland.replace('Z','').replace('T',' '), MySQLDateTimeFormat),
            //moment(item.aanmeldingsdatum.replace('Z','').replace('T',' '), MySQLDateTimeFormat)
        };
        const datum_uitgevoerdConfig = {
            rules: [{ type: 'object', required: false, }],
            initialValue: (action.datum_uitgevoerd)?(moment(action.datum_uitgevoerd.replace('Z','').replace('T',' '), MySQLDateTimeFormat)):(null),
            //initialValue: moment(action.datum_uitgevoerd),
        };
        const opgelostConfig = {
            rules: [{type: 'boolean', required:false, disabled: false}],
            onChange: this.onChangeCheckbox,
        };
        const oplossingtypeConfig = {
            initialValue: action.oplossingtype,
            onChange: this.onChangeOplossingType,
        };
        const oplossingtypeotherConfig = {
            initialValue: action.oplossingtypeother,
            onChange: this.onChange,
        };
        const gecommuniceerd_klantConfig = {
            rules: [{type: 'boolean', required:false, disabled: false}],
            onChange: this.onChangeCheckbox,
        }
        const wat_te_doenConfig = {
            rules: [{type: 'string', required: false, }],
            initialValue: action.wat_te_doen,
            onChange: this.onChange,
        };
        const opmerkingenConfig = {
            rules: [{type: 'string', required: false, }],
            initialValue: action.opmerkingen,
            onChange: this.onChange,
        };
        const meenemenInputConfig = {
            initialValue: action.meenemen,
            rules: [ {type: 'string',}],
            onChange: this.onChange,
        };
        const uren_besteedInputConfig = {
            initialValue: (!isNaN(parseFloat(action.uren_besteed)) && isFinite(action.uren_besteed)) ? (parseFloat(action.uren_besteed)) : (0),
            onChange: this.onChangeUrenBesteedOnChange,
        };

        const isAddForm = this.props.match.params.actionid === '0';

        return (
            <div>
                <Form onSubmit={this.handleSubmit}>

                    <FormItem
                        label="Datum gepland"
                        {...formItemLayout}
                        hasFeedback
                    >
                        {getFieldDecorator('datum_gepland',

                            datum_geplandConfig)(

                            <DatePicker
                                showTime
                                /*dateRender={(current) => {
                                    console.log(`current ${current}`);
                                    return moment(current,DateTimeFormat)
                                }}*/
                                //format={MySQLDateTimeFormat}
                                format={DateTimeFormat}
                                style={{
                                    width: '100%'
                                }}
                                onChange={(date) => this.onChangeDatepicker(date,'datum_gepland')}
                            />
                        )}
                    </FormItem>
                    {
                        !isAddForm ?
                            <div>
                                <FormItem
                                    label="Datum uitgevoerd"
                                    {...formItemLayout}
                                    hasFeedback
                                >
                                    {getFieldDecorator('datum_uitgevoerd',

                                        datum_uitgevoerdConfig)(

                                        <DatePicker
                                            //showTime
                                            /*dateRender={(current) => {
                                                return moment(current,DateTimeFormat)
                                            }}*/
                                            //format={MySQLDateTimeFormat}
                                            format={DateFormat}
                                            style={{
                                                width: '100%'
                                            }}
                                            onChange={(date) => this.onChangeDatepicker(date,'datum_uitgevoerd')}
                                        />
                                    )}
                                </FormItem>
                                <FormItem
                                    label="Opgelost"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('opgelost',

                                        opgelostConfig)(

                                        <Checkbox checked={action.opgelost} />
                                    )}
                                </FormItem>
                                {
                                    action.opgelost ?
                                        <FormItem
                                            label="Oplossing"
                                            {...formItemLayout}
                                        >
                                            {getFieldDecorator('oplossingtype',

                                                oplossingtypeConfig)(

                                                <Select>
                                                    {
                                                        storingtypen.filter(stype => stype.type === this.state.malfunction.storingtype || stype.type === 'Beheer').map(stype => {

                                                            return stype.solutions.map((solution, index) =>
                                                                <Select.Option key={index} value={solution}>{solution}</Select.Option>
                                                            );
                                                        })
                                                    }
                                                </Select>
                                            )}
                                        </FormItem> : ''
                                }
                                {
                                    action.opgelost  && action.oplossingtype === 'Overig' ?
                                    <FormItem
                                        label="Uitleg oplossing"
                                        {...formItemLayout}
                                    >
                                        {getFieldDecorator('oplossingtypeother',

                                            oplossingtypeotherConfig)(
                                            <Input value={action.oplossingtypeother}/>
                                        )}
                                    </FormItem> : ''
                                }
                                <FormItem
                                    label="Gecommuniceerd met klant"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('gecommuniceerd_met_klant',

                                        gecommuniceerd_klantConfig)(

                                        <Checkbox checked={action.gecommuniceerd_met_klant} />
                                    )}
                                </FormItem>
                            </div>: ''
                    }
                    <FormItem
                        label="Wat te doen"
                        {...formItemLayout}
                    >
                        {getFieldDecorator('wat_te_doen',

                            wat_te_doenConfig)(

                            <TextArea rows={4} />
                        )}
                    </FormItem>
                    <FormItem
                        label="Opmerkingen"
                        {...formItemLayout}
                    >
                        {getFieldDecorator('opmerkingen',

                            opmerkingenConfig)(

                            <TextArea rows={4} />
                        )}
                    </FormItem>
                    <FormItem
                        label="Materialen"
                        {...formItemLayout}
                    >
                        {getFieldDecorator('meenemen',

                            meenemenInputConfig)(

                            <TextArea rows={4}/>
                        )}
                    </FormItem>
                    {
                        !isAddForm ?
                            <div>
                                <FormItem
                                    label="Uren besteed"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('uren_besteed',

                                        uren_besteedInputConfig)(
                                        <InputNumber min={0} max={10} step={0.25}/>
                                    )}
                                </FormItem>

                                <FormItem
                                    label="Foto's"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('fotos',
                                    )(<div>
                                        <div>
                                            {action.fotos.map(function (foto, i) {
                                                let adres = filePath + foto.bestand;
                                                return <img alt="" key={i} width={50} height={50} src={adres}
                                                            onClick={() => this.showModal(foto.bestand)}
                                                            style={{paddingLeft: "5px", cursor: "pointer"}}/>
                                            }, this)}
                                        </div>
                                        <div style={{marginBottom: "5px"}}>
                                            <Modal
                                                title=""
                                                width={700}
                                                height={600}
                                                visible={modalIsVisible}
                                                footer={[
                                                    <Button key="cancel" type="primary"
                                                            onClick={this.handleCancel}>Sluit</Button>,
                                                    <Button key="ok" type="danger" onClick={this.removeFoto}>
                                                        Delete
                                                    </Button>,
                                                ]}
                                            >
                                                <div><img alt="" src={filePath + modalImage}
                                                          style={{maxWidth: "650px", maxHeight: "550"}}/></div>
                                            </Modal>
                                        </div>
                                        <FileUpload name='file' multiple={true}
                                                    action='https://fileserver.wijzijnopgewekt.nl/app/upload'
                                                    onError={(info) => {
                                                        message.error(`${info.file.name} file upload failed.`);
                                                    }} onSuccess={(info) => {
                                            message.success(`${info.file.name} file uploaded successfully.`);
                                            this.addDocument(info.file.response.path);
                                        }}
                                                    path={this.state.uploadPath}

                                        /></div>
                                    )}
                                </FormItem>
                            </div> : ''
                    }

                    <FormItem {...tailFormItemLayout}>
                        <Button type="primary" htmlType="submit">Opslaan</Button>
                    </FormItem>
                    <FormItem {...tailFormItemLayout}>
                        <Button type="primary" onClick={()=>this.toOverview(malfunctionid)}>Overzicht storing</Button>
                    </FormItem>
                </Form>
            </div>
        );
    }
}

const WrappedActionEditForm = Form.create()(ActionEditForm);

let mapStateToProps = ({malfunctions}) => ({
    malfunctions: [...malfunctions.malfunctions]
});

export default connect(mapStateToProps)(WrappedActionEditForm);



// WEBPACK FOOTER //
// ./src/components/ActionEditForm.js